import { Controller } from "@hotwired/stimulus"
import { computePosition, flip, offset, shift } from "@floating-ui/dom"

export default class extends Controller {
  static targets = ["trigger", "content"]

  connect() {
    this.updatePosition = this.updatePosition.bind(this)
    this.hideTimeout = null
  }

  show() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
    this.contentTarget.style.display = "block"
    this.updatePosition()
  }

  hide() {
    this.hideTimeout = setTimeout(() => {
      this.contentTarget.style.display = "none"
    }, 100)
  }

  async updatePosition() {
    const { x, y, placement } = await computePosition(
      this.triggerTarget,
      this.contentTarget,
      {
        placement: 'bottom',
        strategy: 'fixed',
        middleware: [
          offset(8),
          flip({ padding: 8 }),
          shift({ padding: 8 })
        ]
      }
    )

    Object.assign(this.contentTarget.style, {
      left: `${x}px`,
      top: `${y}px`
    })
  }
}
